import { AxiosStatic } from "axios";

export const SetCsrfTokenHeader = (axios: AxiosStatic) => {
  // CSRFトークンを格納して初期化する。(SPAでは無いので、ページが変わる度に実行される)
  const token = document?.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
  axios.defaults.headers.common["X-CSRF-Token"] = token;
};

export const getXmlHttpRequestHeader = () => {
  const headers = {
    "X-Requested-With": "XMLHttpRequest",
  };
  return headers;
};
